const selectors = () => ({})

export default selectors
